import { Box, List, Workflow, type LucideIcon } from 'lucide-react';
import { Trans, useTranslation } from 'react-i18next';
import { WizardCallout } from '../components/WizardCallout';

const OUTCOME_CARDS: ReadonlyArray<{ icon: LucideIcon; titleKey: string; bodyKey: string }> = [
  {
    icon: Workflow,
    titleKey: 'initialSetup.outcomes.cards.structure.title',
    bodyKey: 'initialSetup.outcomes.cards.structure.body'
  },
  {
    icon: Box,
    titleKey: 'initialSetup.outcomes.cards.systems.title',
    bodyKey: 'initialSetup.outcomes.cards.systems.body'
  },
  {
    icon: List,
    titleKey: 'initialSetup.outcomes.cards.processes.title',
    bodyKey: 'initialSetup.outcomes.cards.processes.body'
  }
];

/**
 * Screen 2 of the onboarding design: "Das erhältst du am Ende" — the three
 * outcome cards between the welcome screen and the first data step.
 */
export function OutcomesStep() {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-full flex-col justify-center px-16 py-12">
      <h2 className="mb-3 text-center font-display text-[44px] font-extrabold tracking-[-0.02em] text-foreground">
        {t('initialSetup.wizardHeading')}
      </h2>
      <h3 className="mb-3 mt-7 text-center text-2xl font-bold text-foreground">
        {t('initialSetup.outcomes.title')}
      </h3>
      <p className="mx-auto mb-10 max-w-[74ch] text-center text-base text-fg-secondary">
        {t('initialSetup.outcomes.description')}
      </p>
      <div className="mx-auto grid w-full max-w-[1000px] grid-cols-3 gap-5">
        {OUTCOME_CARDS.map(({ icon: Icon, titleKey, bodyKey }) => (
          <div key={titleKey} className="rounded-2xl border border-line bg-surface-subtle p-7">
            <div className="mb-3.5 flex h-10 w-10 items-center justify-center rounded-[10px] bg-bliks-green-500/12 text-bliks-green-700">
              <Icon className="h-5 w-5" strokeWidth={1.8} />
            </div>
            <div className="mb-2 text-[17px] font-bold text-foreground">{t(titleKey)}</div>
            <div className="text-sm leading-[1.5] text-fg-secondary">{t(bodyKey)}</div>
          </div>
        ))}
      </div>
      <WizardCallout variant="hint" className="mx-auto mt-8 w-full max-w-[1000px]">
        <Trans
          i18nKey="initialSetup.outcomes.hint"
          components={{ bold: <strong className="text-foreground" /> }}
        />
      </WizardCallout>
    </div>
  );
}
